import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dropdown"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", {
  class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
], -1)
const _hoisted_3 = { class: "dropdown-menu" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return ($props.company.gap_closing_score !== null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("ul", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: '/company-report/?company_name='+$props.company.name+'&company_website='+$props.company.website,
            class: "dropdown-item d-flex align-items-center"
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createTextVNode(" View Report ")
            ]),
            _: 1
          }, 8, ["to"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.strToStatusMap, (name, status) => {
            return (_openBlock(), _createElementBlock("li", { key: status }, [
              _createElementVNode("a", {
                class: "dropdown-item d-flex align-items-center",
                href: "javascript:void(0);",
                onClick: ($event: any) => ($options.updateStatus($props.company.id, status))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(_ctx.icon + ' lh-1 me-8 position-relative top-1')
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(status), 1)
              ], 8, _hoisted_5)
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}